import React from 'react';
import ReactDOM from 'react-dom';
import CountrySpecificFooterContent from './CountrySpecificFooterContent';

const renderCountrySpecificFooterContent = () => {
  const mountNode = document.querySelector('[react-render-target="country-specific-footer-content"]');
  if (mountNode) ReactDOM.render(<CountrySpecificFooterContent />, mountNode);
  else console.warn('missing render target: CountrySpecificFooterContent');
};

export const initCountrySpecificFooterContent = () => {
  renderCountrySpecificFooterContent();
};
